<template lang="html">
	<el-card class="disclaimer hidden-sm-and-up" v-if="showInstallDialog">
		<div slot="header">{{ $t('disclaimerInstallAppTitle') }}
			<i @click="close" class="el-icon-close" style="float: right; padding: 0 0" type="text"></i>			
		</div>
		<p v-html="$t('disclaimerInstallAppText')"></p>
		<div class="image-container" v-if="isAndroid">
			<a :href="markets.google"><img class="market-image" :src='`./img/google-play-buttons/google-play-badge-${locale}.png`'></img></a>
		</div>
		<div class="image-container" v-else>
			<a :href="markets.apple"><img class="market-image" :src='`./img/app-store-buttons/app-store-button-${locale}.svg`'></img></a>
		</div>
	</el-card>
</template>
<script>
import Settings from '@/Settings.js';
import Helpers from '@/utils/Helpers.js';

export default {
	name: 'InstallAppDialog',
	data: () => ({
		showInstallDialog: false,
		markets: Settings.markets,
		isAndroid: null
	}),
	props: {
		locale: {
			type: String,
			default: 'en'
		}
	},
	created: function () {
		let hide = this.$store.getters.APP_CLOSED;
		if (hide !== true) {
			this.showInstallDialog = true;
		}
		this.isAndroid = Helpers.isAndroid();
	},
	methods: {
		close: function () {
			this.showInstallDialog = false;
			this.$store.commit('CLOSE_APP', true);
		}
	}
}
</script>
<style lang="scss" scoped>
.disclaimer {
	position:fixed;
	top:70px;
	width: 95%;
	margin-left:2.5%;
	.image-container {
		width: 100%;
		text-align:center;
	}
	.market-image {
		width:60%;
		margin:0 auto;
		height: auto;
	}
	p {
		font-size:1.2em;
		margin-bottom:2em;
		margin-top:1em;
		line-height:1.5em;
	}
}
</style>





















